// @ts-nocheck
import React from "react";
import { SecondaryBtn } from "./SecondaryBtn";
import { DangerBtn } from "./DangerBtn";
import PropTypes from "prop-types";
import style from "./InfoCard.module.scss";

import { setCurrentPage } from "../../../reducks/store/Settings/slices";
import { useDispatch } from "react-redux";

import type { AppDispatch } from "../../../reducks/store/store";
import { useTranslation } from "react-i18next";

export const PaymentCard = ({ billing, loading = false, client }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();

  return (
    <>
      <div className={`mb-0 mt-4 ${style.paymentMethod}`}>{t("PaymentCard.請求先情報")}</div>
      <div className={`d-flex align-items-center ${style.card}`}>
        <div className={`d-flex flex-column ${style.cardPaymentInfo}`}>
          <span className="test-card-number">{billing.company_name}</span>
          {billing.billing_email ? (
            <span className={style.email}>{billing.billing_email}</span>
          ) : (
            <span style={{ color: "#cacaca" }}>{t("PaymentCard.メールアドレスが登録されていません")}</span>
          )}
        </div>
        <div className="ml-auto">
          <SecondaryBtn
            text={t("PaymentCard.変更")}
            className="test-change-card mx-1"
            disabled={loading ? true : false}
            style={{
              padding: "3px 10px",
              borderRadius: "30px",
              minWidth: "68px",
              minHeight: "38px",
              height: "38px",
              fontWeight: 600,
            }}
            submit={() => dispatch(setCurrentPage("company-billing-info"))}
            dataTestId="test-change-billing-info-btn"
          />
        </div>
      </div>
    </>
  );
};

PaymentCard.propTypes = {
  billing: PropTypes.object,
  loading: PropTypes.bool,
  client: PropTypes.string,
};
